/* eslint-disable */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from "react";
import { columnPreviewInterface } from "../../../../../types/type";
import UxEvaluationTag from "../../tag/UxEvaluationTag";
import AuthorContactBtn, { AuthorContactBtnProps } from "./AuthorContactBtn";
import { AUTHOR_CONTACT_TYPE, DATA_SOURCE } from "../../../../../types/enum";
import { ShowAuthorContactBtn } from "../../../mobile/ShowAuthorContactBtn";
import { Spinner } from "../../../../../shared/ui";
import { useImageLoad } from "../../../../../shared/hooks";
import { useTranslation } from "../../../../../shared/hooks/useTranslation";

const ColumnPreview = React.memo(function ColumnPreview(
  props: columnPreviewInterface,
) {
  const { t } = useTranslation();

  const authorLinkForMobile: AuthorContactBtnProps[] = [
    props.author?.authorInsta &&
      props.author?.authorInsta !== "" && {
        btnType: AUTHOR_CONTACT_TYPE.INSTAGRAM,
        link: props.author.authorInsta,
      },
    props.author?.authorLinkedin &&
      props.author?.authorLinkedin !== "" && {
        btnType: AUTHOR_CONTACT_TYPE.LINKEDIN,
        link: props.author.authorLinkedin,
      },
    props.author?.authorEmail &&
      props.author?.authorEmail !== "" && {
        btnType: AUTHOR_CONTACT_TYPE.EMAIL,
        link: props.author.authorEmail,
      },
    {
      btnType: AUTHOR_CONTACT_TYPE.ARTICLE_LINK,
      link: props.id,
    },
  ].filter(Boolean) as AuthorContactBtnProps[];
  // 현재 경로가 이미 /detail/로 시작하는지 확인
  const currentPath = window.location.pathname;
  const basePath = currentPath.startsWith("/detail/") ? "/" : currentPath;
  const url = window.location.origin + basePath + "detail/" + `${props.id}`;

  const onClickDetail = () => {
    props.onClickDetail(props.id);
    props.setIsOpened(true);
    window.history.pushState(null, "", url);
  };

  // 이미지 로딩을 위한 컴포넌트
  const ImageWithSpinner = ({
    imageUrl,
    index,
  }: {
    imageUrl: string;
    index: number;
  }) => {
    const { data: loadedImageUrl, isLoading, error } = useImageLoad(imageUrl);

    if (isLoading) {
      return (
        <div className="img-container">
          <Spinner size="medium" className="spinner" />
        </div>
      );
    }

    if (error || !loadedImageUrl) {
      return (
        <div className="img-container">
          <div className="image-error">{t("article.imageError")}</div>
        </div>
      );
    }

    return (
      <div className="img-container">
        <img
          alt="preview-img"
          src={loadedImageUrl}
          className="preview-img visible"
        />
      </div>
    );
  };

  // Product 이미지 로딩을 위한 컴포넌트
  const ProductImageWithSpinner = ({
    imageUrl,
  }: {
    imageUrl: string | undefined;
  }) => {
    const { data: loadedImageUrl, isLoading, error } = useImageLoad(imageUrl);

    if (isLoading) {
      return (
        <div className="product-icon-container">
          <Spinner size="small" className="product-spinner" />
        </div>
      );
    }

    if (error || !loadedImageUrl) {
      return (
        <div className="product-icon-container">
          <div className="product-icon-error">{t("article.noImage")}</div>
        </div>
      );
    }

    return (
      <img alt="product-icon" className="product-icon" src={loadedImageUrl} />
    );
  };

  // 다국어 제품명 처리 (현재는 단일 name 필드만 있음)
  // TODO: 나중에 nameKo, nameEn 필드가 추가되면 다국어 지원으로 변경
  const productName = props.product?.name || "";

  return (
    <div className="column-component" onClick={onClickDetail}>
      <div className="top-line">
        <div className="title">{props.title}</div>
        {/*</Link>*/}
        <div className="title-divide-bar"></div>
        <ProductImageWithSpinner imageUrl={props.product?.imageUrl} />
        <div className="product-name">{productName}</div>
        <UxEvaluationTag name={props.uxEvaluation!} />
      </div>
      <div className="content-container">
        <div className="content-wrapper">
          <UxEvaluationTag name={props.uxEvaluation!} />

          <div className="img-wrapper">
            {props.imageSrc?.map((el, idx) => (
              <ImageWithSpinner
                key={(el.imageUrl || "") + idx}
                imageUrl={el.imageUrl || ""}
                index={idx}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="preview-footer">
        <div className="author-wrapper">
          <div className="author-title">
            <div className="author-text">{t("article.author")}</div>
            <div className="author-name">{props.author?.authorName}</div>
          </div>
          <div className="author-contact-box">
            {props.author?.authorEmail && props.author?.authorEmail !== "" ? (
              <AuthorContactBtn
                btnType={AUTHOR_CONTACT_TYPE.EMAIL}
                link={props.author?.authorEmail || ""}
              />
            ) : null}
            {props.author?.authorInsta && props.author?.authorInsta !== "" ? (
              <AuthorContactBtn
                btnType={AUTHOR_CONTACT_TYPE.INSTAGRAM}
                link={props.author?.authorInsta || ""}
              />
            ) : null}
            {props.author?.authorLinkedin &&
            props.author?.authorLinkedin !== "" ? (
              <AuthorContactBtn
                btnType={AUTHOR_CONTACT_TYPE.LINKEDIN}
                link={props.author?.authorLinkedin || ""}
              />
            ) : null}
          </div>
          <div className="author-contact-mobile-box">
            <ShowAuthorContactBtn
              key={props.id}
              keyId={props.id || ""}
              btnType={authorLinkForMobile}
            />
          </div>
        </div>
        <div className="copyright-wrapper">
          {t("copyright.uiCopyright")} {props.product ? props.product.name : ""}{" "}
          {props.dataSource !== DATA_SOURCE.CUSTOM
            ? `, ${t("copyright.viaMobbin")}`
            : null}
        </div>
      </div>
    </div>
  );
});

export default ColumnPreview;
